<template>
	<div class="layout">
		<div id="layout-title">
			<div id="layout-title-left">
				<img src="/static/imgs/cangku.png" class="jxyd-imgicon"/>
				仓库管理
			</div>
			<div id="layout-title-right">
				<Dropdown style="margin-right:10px;">
					<a href="javascript:void(0)" class="jxyd-a">
						下载模板
						<Icon type="ios-arrow-down"></Icon>
					</a>
					<DropdownMenu slot="list">
						<DropdownItem>
							<a href="/static/仓库导入模板.xlsx" class="jxyd-a">仓库数据模板</a>
						</DropdownItem>
						<DropdownItem>
							<a href="/static/货位导入模板.xlsx" class="jxyd-a">货位数据模板</a>
						</DropdownItem>
					</DropdownMenu>
				</Dropdown>
				<button class="jxyd-button" title="新建仓库" @click="addDepot"
					style="margin-right:10px;" v-show="permission.isAdd_d">
					<Icon type="md-add-circle" size='18'/> 新建
				</button>
				<Dropdown style="margin-right:10px;">
					<a href="javascript:void(0)" class="jxyd-a">
						批量操作
						<Icon type="ios-arrow-down"></Icon>
					</a>
					<DropdownMenu slot="list">
						<Upload action="/api/Util/UploadExcel" :show-upload-list="false"
							:max-size="2048" :format="['xlsx','xls']" :on-format-error="batchAddDepotFormatError"
							:on-exceeded-size="uploadFileSizeError" :on-success="batchAddDepotSuccess"
							:on-error="batchAddDepotError" v-show="permission.isBatchImport_d">
							<DropdownItem class="dropdown-item">
								<Icon type="md-exit" size='18'/> 批量导入
							</DropdownItem>
						</Upload>
					</DropdownMenu>
				</Dropdown>
			</div>
		</div>

		<div id="layout-box">
			<div id="box-search">
				<Form ref="formSearch" :label-width="70" :model="searchItems" inline>
					<FormItem label="仓库列表">
						<Input type="text" v-model="searchItems.depotName" placeholder="仓库列表"
							@keyup.enter.native="initListData(1)" />
					</FormItem>
					<div style="display:inline-block;" v-show="advancedSelect">
						<FormItem label="负责人">
							<Select v-model="searchItems.userId" filterable clearable
								@keyup.enter.native="initListData(1)">
								<Option v-for="item in userList" placeholder="请选择负责人" :value="item.id"
									:key="item.userDisplayName">
									{{item.userDisplayName}}
								</Option>
							</Select>
						</FormItem>
						<FormItem label="是否启用">
							<Select v-model="searchItems.isUse" @on-change="initListData(1)">
								<Option :value="-1" :key="-1">请选择</Option>
								<Option :value="0" :key="0">否</Option>
								<Option :value="1" :key="1">是</Option>
							</Select>
						</FormItem>
						<FormItem label="备注">
							<Input type="text" v-model="searchItems.note" placeholder="备注"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
					</div>
					<FormItem :label-width="20">
						<button class="jxyd-button jxyd-primary" @click="initListData(1)" style="margin-right:10px;">查询</button>
						<button class="jxyd-button" @click="initSearch" style="margin-right:10px;">重置</button>
						<span @click="advancedSelect = true;" style="color:red;cursor: pointer;" v-if="!advancedSelect">
							展开
							<Icon type="ios-arrow-down" size='18'/>
						</span>
						<span @click="foldSearch" style="color:red;cursor: pointer;" v-else>
							折叠
							<Icon type="ios-arrow-up" size='18'/>
						</span>
					</FormItem>
				</Form>
			</div>
			<div id="box-table">
				<Table row-key="guid" ref="depotList" :columns="tableColumns" :data="depotData"></Table>
			</div>
			<div id="page-box">
				<Page show-sizer :total="depotCount" :page-size="searchItems.pageSize" @on-change="pageChange"
					show-total show-elevator :page-size-opts ='pageSizeOpts' :current="searchItems.pageIndex" @on-page-size-change='pageSizeChange'>
				</Page>
			</div>
		</div>

		<Modal v-model="modalDisPlay" draggable sticky scrollable>
			<p slot="header" class="modal-header">
				<img src="/static/imgs/cangku.png" class="jxyd-imgicon"/>
				<span> 操作仓库</span>
			</p>
			<div style="background-color:#fff;border-radius:5px;padding:20px;">
				<Form ref="formDepot" :model="formItem" :label-width="70" :rules="ruleDepot">

					<Form-item label="仓库名" prop="depotName">
						<Input v-model="formItem.depotName" placeholder="请输入" size="large" />
					</Form-item>
					<Form-item label="负责人" prop="userId">
						<Select v-model="formItem.userId" filterable clearable>
							<Option v-for="item in userList" placeholder="请选择负责人" :value="item.id"
								:key="item.userDisplayName">
								{{item.userDisplayName}}
							</Option>
						</Select>
					</Form-item>
					<Form-item label="是否启用" prop="isUse">
						<i-Switch v-model="formItem.isUse" size="large" />
					</Form-item>

					<Form-item label="备注" prop="note">
						<Input v-model="formItem.note" type="textarea" placeholder="请输入" size="large" />
					</Form-item>
				</Form>
			</div>
			<div slot="footer">
				<button class="jxyd-button" @click="cancel('formDepot')">取消</button>
				<Button class="jxyd-borderbtn" @click="depotSubmit(1)">保存</Button>
				<Button class="jxyd-borderbtn" @click="depotSubmit(2)">保存并继续</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		name: 'depotmanage',
		components: {
		},
		data() {
			return {
				searchItems: {
					depotName: '',
					userId: 0,
					isUse: -1,
					note: '',
					pageSize: 10,
					pageIndex: 1,
				},
				depotCount: 0,
				modalDisPlay: false,
				modalUser: false,
				modalTree: false,
				tableColumns: [{
						title: '仓库列表',
						key: 'depotName',
						tree: true,
						render(h, params) {
							return [h('img', {
								style: {
									
								},
								attrs: {
									class: "jxyd-imgicon",
									src:params.row.type == "Depot" ? "/static/imgs/cangku.png":"/static/imgs/weizhi.png"
								}
							}), " " + params.row.depotName]
						}
					},
					{
						title: '负责人',
						key: 'userDisplayName'
					},
					{
						title: '是否启用',
						key: 'isUse',
						render: (h, params) => {
							return h('i-Switch', {
								attrs: {
									'value': params.row.isUse,
									'disabled': !this.permission.isUse
								},
								on: {
									'on-change': (e) => {
										params.row.isUse = e;
										let self = this;
										let tag = '';
										let url = "";

										if (e) {
											tag = '启用';
										} else {
											tag = '停用';
										}

										this.$Modal.confirm({
											title: "操作警告",
											content: "是否确认" + tag + "“" + params.row
												.depotName + "”？",
											onOk() {
												request.get("/api/Depot/EditUse", {
													params: {
														id: params.row.id,
														isUse: e
													}
												}).then(function(response) {
													if (response.state == 0) {
														self.$Notice.error({
															title: '错误提示',
															duration: 3,
															desc: '更新失败:' +
																response
																.errorMsg
														});
														return;
													}
													self.$Notice.success({
														title: '正确提示',
														duration: 3,
														desc: '更新成功!'
													});
													self.initListData(1);
												}).catch(function(error) {
													self.initListData(1);
												})
											},
											onCancel() {
												self.initListData(1);
											}
										});
									}
								}
							})
						}
					},
					{
						title: '备注',
						key: 'note'
					},
					{
						title: '操作',
						key: 'action',
						width: 245,
						align: 'center',
						fixed: 'right',
						render: (h, params) => {
							var btnArr = [];
							if (this.permission.isEdit_d) {
								btnArr.push(h('i-button', {
									style: {
										'margin-right': '5px'
									},
									attrs: {
										type: `dashed`,
										class: "ivu-btn ivu-btn-dashed ivu-btn-small"
									},
									on: {
										click: (e) => {
											this.formItem.id = params.row.id;
											this.formItem.depotName = params.row.depotName;
											this.formItem.userId = params.row.userId;
											this.formItem.isUse = params.row.isUse;
											this.formItem.note = params.row.note;
											this.formItem.creator = params.row.creator;
											this.formItem.createDate = params.row.createDate;
											this.modalDisPlay = true;
										}
									},
								}, "编辑"));
							}
							
							if (this.permission.isDelete_d) {
								btnArr.push(h('i-button', {
									style: {
										'margin-right': '5px'
									},
									attrs: {
										type: `error`,
										class: "ivu-btn ivu-btn-error ivu-btn-small"
									},
									on: {
										click: (e) => {
											this.deleteDepot([params.row.id]);
										}
									},
								}, "删除"));
							}
							return btnArr;
						}
					}
				],
				depotData: [],
				userList: [],
				formItem: {
					id: 0,
					depotName: '',
					userId: parseInt(localStorage.getItem("userId")),
					isUse: true,
					note: '',
					creator: parseInt(localStorage.getItem("userId"))
				},
				ruleDepot: {
					depotName: [{
							required: true,
							message: '请填写仓库名',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 20,
							message: '输入不得大于20个字',
							trigger: 'blur'
						}
					],
					userId: [{
						required: true,
						type: 'number',
						message: '请选择负责人',
						trigger: 'change'
					}],
					note: [{
							required: false,
							message: '',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 50,
							message: '输入不得大于50个字',
							trigger: 'blur'
						}
					]
				},
				treeData: [],
				advancedSelect: true,
				permission: {
					isDelete_cd: false,
					isEdit_cd: false,
					isAdd_cd: false,
					isAdd_d: false,
					isEdit_d: false,
					isDelete_d: false,
					isBatchImport_d: false,
					isUse: false
				},
				pageSizeOpts:[10,20,30,40,50,60,70,80,90,100]
			}
		},

		methods: {
			initListData(index) {
				let component = this;
				component.searchItems.pageIndex = index;
				request.post('/api/Depot/GetDepotList', component.searchItems).then(function(response) {
					if (response.state == 0) {
						component.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}

					component.depotData = response.data.depot;
					component.depotCount = response.data.depotCount;
				}).catch(function(error) {})
			},
			initUserToSelect() { //初始化用户下拉框数据源
				let component = this;
				request.get('/api/User/GetUserToSelect').then(function(response) {
					if (response.state == 0) {
						component.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					component.userList = response.data;
				}).catch(function(error) {})
			},
			depotSubmit(type) {
				this.$refs['formDepot'].validate((valid) => {
					if (valid) {
						let component = this;
						request.post('/api/Depot/EditDepot', component.formItem).then(function(response) {
							if (response.state == 0) {
								component.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: '保存失败:' + response.errorMsg
								});
								return;
							}

							component.initListData(1);
							component.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '保存成功!'
							});
							if (type == 1) {
								component.modalDisPlay = false;
							} else {
								component.$refs['formDepot'].resetFields();
								component.formItem
								component.formItem.id = 0;
							}
						}).catch(function(error) {})
					}
				})
			},
			cancel(name) {
				this.modalDisPlay = false;
				//清空form规则检查
				this.$refs[name].resetFields();
			},
			addDepot() {
				this.modalDisPlay = true;
				this.$refs['formDepot'].resetFields();
				this.formItem.id = 0;
			},
			deleteDepot(ids) {
				var component = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "仓库的货位也将删除且不可恢复，是否继续操作？",
					onOk() {
						request.post('/api/Depot/DeleDepot', ids).then(function(response) {

							if (response.state == 0) {
								component.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							component.initListData(1);
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			pageChange(index) {
				this.initListData(index);
			},
			pageSizeChange(pageSize){
				this.searchItems.pageSize = pageSize;
				this.initListData(1);
			},
			batchAddDepotSuccess(response, file, fileList) {
				if (response.state == 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '导入失败：' + response.errorMsg + '!'
					});
					return;
				}
				let component = this;
				request.post('/api/Depot/BatchAddDepot', {
					Path: response.data,
					Creator: localStorage.getItem("userId")
				}).then(function(response) {
					if (response.state == 0) {
						component.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "导入失败：" + response.errorMsg
						});
						return;
					}

					component.initListData(1);
				}).catch(function(error) {})
			},
			batchAddDepotError(error, file, fileList) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '上传失败：' + error + '!'
				});
			},
			batchAddDepotFormatError(file) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '导入失败：请选择xls、xlsx格式文件！'
				});
			},
			uploadFileSizeError(file) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '导入失败：不可选择超过2M大小文件！'
				});
			},
			foldSearch() {
				this.advancedSelect = false;
				this.searchItems.userId = 0;
				this.searchItems.isUse = -1;
				this.searchItems.note = ''
			},
			initSearch() {
				this.searchItems.depotName = '';
				this.searchItems.userId = 0;
				this.searchItems.isUse = -1;
				this.searchItems.note = ''
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['CommodityAddress.Delete', 'CommodityAddress.Edit', 'CommodityAddress.Add',
						'Depot.Add', 'Depot.Edit', 'Depot.Delete', 'Depot.BatchImport', 'Depot.IsUse'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if(tipTimeoutCount != undefined){
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					}else if(response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)){
						self.$Modal.warning({
							title:'系统到期提示',
							content: response.errorMsg,
							onOk:() => {
								localStorage.setItem("_tipTimeoutCount",1);
							}
						});
					}
					if(tipTimeoutCount == undefined || tipTimeoutCount < 1000){
						localStorage.setItem("_tipTimeoutCount",tipTimeoutCount == undefined ? 1 : tipTimeoutCount+1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'CommodityAddress.Delete':
								self.permission.isDelete_cd = response.data[i].permission
								break;
							case 'CommodityAddress.Edit':
								self.permission.isEdit_cd = response.data[i].permission
								break;
							case 'CommodityAddress.Add':
								self.permission.isAdd_cd = response.data[i].permission
								break;
							case 'Depot.Add':
								self.permission.isAdd_d = response.data[i].permission
								break;
							case 'Depot.Edit':
								self.permission.isEdit_d = response.data[i].permission
								break;
							case 'Depot.Delete':
								self.permission.isDelete_d = response.data[i].permission
								break;
							case 'Depot.BatchImport':
								self.permission.isBatchImport_d = response.data[i].permission
								break;
							case 'Depot.IsUse':
								self.permission.isUse = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			}
		},
		watch: {},
		created: function() {
			this.initListData(1);
			//this.initUserData();
			this.initUserToSelect();
			this.initPermission();
		}
	}
</script>

<style scoped>
	.layout {
		background: #fff;
		border-radius: 8px;
		padding: 5px 10px;
	}

	#layout-title {
		overflow: hidden;
		padding: 5px;
		font-size: 16px;
		border-bottom: 1px solid #e8eaec;
	}

	#box-search {
		padding-top: 20px;
	}

	#layout-title-left {
		float: left;
		height: 25px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	#layout-title-right {
		float: right;
	}

	#page-box {
		margin-top: 20px;
		text-align: center;
	}
	
	.dropdown-item{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.modal-header{
		display: flex;
		justify-content: left;
		align-items: center;
	}
</style>